import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./HomePage.css";
import { supabase } from "../Utils/supabase";

function HomePage() {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          }
        }
      });

      if (error) {
        setError("Failed to login with Google. Please try again.");
        console.error("Google login error:", error);
      }
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Only redirect if user is authenticated and has admin role
  if (user?.role === 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="logo-container">
          <div className="logo">
            <i className="fas fa-microscope"></i>
          </div>
        </div>
        <h1>Uropine Admin Portal</h1>
        <p>Advanced Healthcare Management System</p>
      </div>

      <div className="login-cards-container">
        <div className="login-card admin">
          <div className="card-icon">
            <i className="fas fa-user-shield"></i>
          </div>
          <h2>Admin Login</h2>
          <p>System administration and user management</p>
          <form className="login-form" onSubmit={handleGoogleLogin}>
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Signing in..." : "Sign in with Google"}
            </button>
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>

        <div className="login-card hospital">
          <div className="card-icon">
            <i className="fas fa-hospital"></i>
          </div>
          <h2>Hospital Login</h2>
          <p>Access hospital administration and patient management</p>
          <div className="coming-soon-badge">Coming Soon</div>
        </div>
      </div>

      <div className="features-section">
        <h2>Platform Features</h2>
        <div className="features-container">
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-chart-line"></i>
            </div>
            <h3>Analytics Dashboard</h3>
            <p>Comprehensive healthcare analytics and reporting</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-user-clock"></i>
            </div>
            <h3>Appointment Management</h3>
            <p>Streamlined scheduling and patient coordination</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-file-medical-alt"></i>
            </div>
            <h3>Electronic Records</h3>
            <p>Secure patient data management system</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
